export const SET_DISPLAYS = 'SET_DISPLAYS';
export const SET_DISPLAY_LIST = 'SET_DISPLAY_LIST';
export const SET_DISPLAY_LIST_FILTER = 'SET_DISPLAY_LIST_FILTER';
export const SET_SELECTED_DISPLAY = 'SET_SELECTED_DISPLAY';

export function setDisplays(displays) {
  return {
    type: SET_DISPLAYS,
    payload: displays,
  };
}

export function setDisplayList(list) {
  return {
    type: SET_DISPLAY_LIST,
    payload: list,
  };
}

export function setDisplayListFilter(filter) {
  return {
    type: SET_DISPLAY_LIST_FILTER,
    payload: filter,
  };
}

export function setSelectedDisplay(display) {
  return {
    type: SET_SELECTED_DISPLAY,
    payload: display,
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/display/actions.js
 **/